import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import faqList from "../assets/data/faqData";

const FaqItem = ({ faq }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id="panel-header">
        <Typography variant="h6">{faq.question}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body1" color="textSecondary">
          {faq.answer}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

FaqItem.propTypes = {
  faq: PropTypes.object.isRequired,
};

const FaqSection = () => {
  return (
    <section className="py-10 bg-white dark:bg-[#0b1727] text-zinc-900 dark:text-white">
      <Container>
        <div className="text-center mb-6">
          <Typography variant="h4" gutterBottom>
            Frequently Asked Questions
          </Typography>
          <Typography variant="body1">
            It's easier to achieve your geological exploration goals when you have the right tools. 
            Explore the best resources to support your journey!
          </Typography>
        </div>

        <Grid container spacing={3}>
          {faqList.map((faq, index) => (
            <Grid item xs={12} md={6} key={index}>
              <FaqItem faq={faq} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default FaqSection;
